import { defineMessages } from "react-intl";

const messages = defineMessages({
    noResults: {
        id: "browse.noResults",
    },
});

export default messages;
